// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {useQuery, PopoverType} from '@supermove/hooks';
import {TagModel} from '@supermove/models';

// Components
import PopoverWithAction from '@shared/design/components/Popover/PopoverWithAction';
import ProjectTagsField from '@shared/modules/Project/components/ProjectTagsField';
import TagCategory from '@shared/modules/Tag/enums/TagCategory';
import TagAssignmentForm from '@shared/modules/Tag/forms/TagAssignmentForm';
import useUpsertTagAssignmentMutation from '@shared/modules/Tag/hooks/useUpsertTagAssignmentMutation';

const EditProjectTagsPopover = ({
  projectId,
  projectUuid,
  tagIds,
  popover,
  children,
}: {
  projectId: string;
  projectUuid: string;
  tagIds: number[];
  popover: PopoverType;
  children: React.ReactNode;
}) => {
  const tagAssignmentForm = TagAssignmentForm.new({projectId, tagIds});
  const {form, submitting, handleSubmit} = useUpsertTagAssignmentMutation({
    tagAssignmentForm,
    onSuccess: popover.handleClose,
    onError: (errors) => {
      console.log({errors});
    },
  });

  const {data} = useQuery(EditProjectTagsPopover.query, {
    fetchPolicy: 'cache-and-network',
    variables: {
      categories: [TagCategory.PROJECT],
      projectUuid,
    },
    skip: !popover.isOpen,
  });

  return (
    <PopoverWithAction
      popover={popover}
      placement={'bottom-end'}
      offset={[-6, 8]}
      drawerHeaderText={'Edit Call Tags'}
      handleSubmit={handleSubmit}
      isSubmitting={submitting}
      contentComponent={
        <React.Fragment>
          <ProjectTagsField
            form={form}
            tags={
              data?.project.organization.companySettings.tags.filter(
                (tag: TagModel) => tag.category === TagCategory.PROJECT,
              ) || []
            }
          />
        </React.Fragment>
      }
    >
      {children}
    </PopoverWithAction>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
EditProjectTagsPopover.query = gql`
  ${ProjectTagsField.fragment}

  query EditProjectTagsPopover($projectUuid: String!) {
    ${gql.query}
    project(uuid: $projectUuid) {
      id
      organization {
        id
        companySettings {
          tags {
            id
            category
            ...ProjectTagsField
          }
        }
      }
    }
  }
`;

export default EditProjectTagsPopover;
